import { Pyramid, Settings, ShieldHalf } from "lucide-react";
import { MENU_QUEST_TOOLTIPS } from "../constants/menuTooltips";
import CrownIcon from "./IconComponent/CrownIcon";
import QuestIcon from "./IconComponent/QuestIcon";
import MenuIconTooltip from "./MenuIconTooltip";

export default function MenuQuestNav({
  screen = "daily",
  onScreenChange = () => {},
  onSettingsClick = () => {},
  visible = true,
}) {
  if (!visible) return null;

  return (
    <div className="menuFilterContainer menuQuestNavContainer">
      <MenuIconTooltip
        tooltip={MENU_QUEST_TOOLTIPS.daily}
        placement="left"
        portal
        className={screen === "daily" ? "filterIcon active" : "filterIcon"}
      >
        <QuestIcon
          size={50}
          color="#39210d"
          onClick={() => onScreenChange("daily")}
          aria-label="Quêtes du jour"
          style={{ cursor: "pointer" }}
        />
      </MenuIconTooltip>

      <MenuIconTooltip
        tooltip={MENU_QUEST_TOOLTIPS.treasures}
        placement="left"
        portal
        className={screen === "treasures" ? "filterIcon active" : "filterIcon"}
      >
        <Pyramid
          size={50}
          color="#39210d"
          strokeWidth={1}
          onClick={() => onScreenChange("treasures")}
          aria-label="Salle des trésors de quête"
          style={{ cursor: "pointer" }}
        />
      </MenuIconTooltip>

      <MenuIconTooltip
        tooltip={MENU_QUEST_TOOLTIPS.titles}
        placement="left"
        portal
        className={screen === "titles" ? "filterIcon active" : "filterIcon"}
      >
        <CrownIcon
          size={50}
          color="#39210d"
          strokeWidth={1}
          onClick={() => onScreenChange("titles")}
          aria-label="Avancement des titres"
          style={{ cursor: "pointer" }}
        />
      </MenuIconTooltip>

      <MenuIconTooltip
        tooltip={MENU_QUEST_TOOLTIPS.blasons}
        placement="left"
        portal
        className={screen === "blasons" ? "filterIcon active" : "filterIcon"}
      >
        <ShieldHalf
          size={50}
          color="#39210d"
          strokeWidth={1}
          onClick={() => onScreenChange("blasons")}
          aria-label="Armorial de Vocabularium"
          style={{ cursor: "pointer" }}
        />
      </MenuIconTooltip>

      <MenuIconTooltip
        tooltip={MENU_QUEST_TOOLTIPS.settings}
        placement="left"
        portal
        className="filterIcon"
      >
        <Settings
          size={50}
          color="#39210d"
          strokeWidth={1}
          onClick={onSettingsClick}
          aria-label="Paramètres des quêtes"
          style={{ cursor: "pointer" }}
        />
      </MenuIconTooltip>
    </div>
  );
}
